module.exports = __webpack_public_path__ + "img/03307ff.png";